import { format } from 'date-fns';

/**
 * @param {string} airportCity - The city of the airport.
 * @returns {string} The formatted airport city name.
 */
export const shortenAirportCityString = (airportCity) => {
  if (!airportCity) {
    return '';
  }
  const cityBegining = airportCity.slice(0, 10)?.toLowerCase();
  return `${cityBegining.charAt(0).toUpperCase() + cityBegining.slice(1)}${airportCity.length > 10 ? '...' : ''}`;
};

/**
 * @param {object} param
 * @param {string} param.airportCode
 * @param {string} param.airportCity
 * @param {string} [param.date]
 * @param {string} [param.time]
 * @returns {string}
 */
export const displayDestionationInfo = ({
  airportCode, airportCity, date, time,
}) => {
  const formattedDate = date ? format(new Date(date), 'dd/MM/yyyy') : '';
  const formattedTime = time ? `- ${time}` : '';
  return `${airportCode?.toUpperCase()} - ${shortenAirportCityString(airportCity)} \n ${formattedDate} ${formattedTime}`;
};

/**
 * Get the label of an airport.
 * @param {string} code - The airport code.
 * @param {string} city - The airport city.
 * @returns {string} The airport label.
 */
export const getAirportLabel = (code, city) => {
  const formattedCity = city ? city.charAt(0).toUpperCase() + city.slice(1).toLowerCase() : '';
  return `${code?.toUpperCase()} ${formattedCity}`;
};
